// extracted by mini-css-extract-plugin
export var growableInput = "_3g-0";
export var tagContainer = "_3g-2";
export var textInput = "_3g-1";